import Vue from 'vue';

// errors deliberately propagate to the store actions so callers can tell a
// timeout from a rejection — swallowing them here left charged payments
// looking like undefined responses
export const generateInPersonPaymentIntentRequest = ({ session, order }) => {
  return Vue.axios.post(`/payments/worldline/create-sale-transaction`, {
    session,
    order,
  });
};

export const updateInPersonPaymentIntentRequest = ({ session, data, type }) => {
  return Vue.axios.post(`/payments/worldline/callback`, {
    data: {
      session,
      ...data,
    }, // terminal data
    type, // 'payment_succeeded' | 'payment_failed' | 'payment_info_event' | 'settlement_succeeded'
  });
};

export const fetchPaymentByUUIDRequest = async ({ paymentUUID }) => {
  return await Vue.axios.get(`/payments/payment-by-uuid/${paymentUUID}`);
};
